import { useAuth } from "#/feature/auth/auth-context";
import { checkAuth } from "#/feature/auth/auth-store";
import { ForgotPasswordPage } from "#/feature/auth/forgot-password-page";
import { LoginPage } from "#/feature/auth/login-page";
import { TotpSetupPage } from "#/feature/auth/totp-setup-page";
import { NoConnectionPage } from "#/feature/auth/no-connection-page";
import { ChapterPage } from "#/feature/chapter/chapter-page";
import { BookPage } from "#/feature/book/book-page";
import { Jobs } from "#/feature/jobs/jobs-page";
import { Library } from "#/feature/library/library-page";
import { Search } from "#/feature/search/search-page";
import { Sources } from "#/feature/sources/sources-page";
import { UserPage } from "#/feature/user/user-page";
import { Route, Routes, useLocation } from "react-router-dom";
import { initTtsStore } from "#/feature/tts-playback/tts-store";
import { Activity, useEffect } from "react";
import { CapacitorApp } from "./capacitor-app";
import { mainStyles } from "./capacitor-app.css";

/**
 * App entry: Capacitor shell + session bootstrap + routed UI.
 */
export function App() {
  useEffect(() => {
    void checkAuth();
  }, []);
  useEffect(() => initTtsStore(), []);
  return (
    <CapacitorApp>
      <MainContent />
    </CapacitorApp>
  );
}

/**
 * Session-aware main area: loading / offline gates, then library Activity + routed pages.
 */
function MainContent() {
  const location = useLocation();
  const { isLoading, connectionError } = useAuth();
  const isLibraryRoute = location.pathname === "/";
  if (isLoading) {
    return (
      <main className={mainStyles}>
        <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>Loading...</div>
      </main>
    );
  }
  if (connectionError) {
    return (
      <main className={mainStyles}>
        <NoConnectionPage />
      </main>
    );
  }
  return (
    <main className={mainStyles}>
      {/* Library stays mounted but hidden when not on "/" route */}
      <Activity mode={isLibraryRoute ? "visible" : "hidden"}>
        <Library />
      </Activity>
      <Routes>
        <Route path="/" element={null} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register/totp" element={<TotpSetupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/user" element={<UserPage />} />
        <Route path="/book/:id" element={<BookPage />} />
        <Route path="/book/:id/chapter/:chapterId" element={<ChapterPage />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/search" element={<Search />} />
        <Route path="/jobs" element={<Jobs />} />
      </Routes>
    </main>
  );
}
